module.exports = __webpack_public_path__ + "static/media/bacimg.2d9f7955.jpg";